import React, { useEffect, useRef } from "react";
import { retry } from "@catchoftheday/utilities";
import { useUpdateUserLocationMutation, useUserLocationQuery, } from "../../generated/graphql.jsx";
import { formatLocation, LocationWidget, } from "../LocationWidget/index.js";
export function UserLocationWidget({ onLocationSelected, onLocationUpdateLoading, onLocationUpdateError, onLocationUpdateCompleted, ...rest }) {
    const { data: query } = useUserLocationQuery();
    const userLocation = query?.userLocation;
    const initialLocationModel = userLocation && "location" in userLocation
        ? userLocation.location
        : undefined;
    const initialLocationDisplay = (initialLocationModel && formatLocation(initialLocationModel)) ?? undefined;
    const initialLocationSet = useRef(false);
    // Set user's current location
    const [_updateUserLocation] = useUpdateUserLocationMutation();
    const updateUserLocation = async (id, location) => {
        onLocationSelected?.(id, location);
        if (!id)
            return;
        const locationId = `${id}`;
        try {
            onLocationUpdateLoading && onLocationUpdateLoading();
            await retry(_updateUserLocation)({
                variables: { input: { locationId } },
                onCompleted: (data) => {
                    onLocationUpdateCompleted && onLocationUpdateCompleted();
                },
            });
        }
        catch (e) {
            onLocationUpdateError && onLocationUpdateError();
        }
    };
    // Once the initial location is set, call the selected callback.
    useEffect(() => {
        // Ensure onLocationSelected is only invoked once, when initial location is fetched
        if (!initialLocationModel || initialLocationSet.current)
            return;
        initialLocationSet.current = true;
        onLocationSelected?.(initialLocationModel.id, initialLocationModel);
    }, [initialLocationModel, onLocationSelected]);
    // Using `key` to force re-render as a new component when initialLocationDisplay changes.
    return (<LocationWidget key={initialLocationDisplay ? "default" : "with-location"} {...rest} initialLocation={initialLocationDisplay} onLocationSelected={updateUserLocation}/>);
}
